import { Component, OnInit, Output, EventEmitter } from '@angular/core'
import { environment } from '../../../../../../environments/environment'
import { CommonService } from '../../../../../shared/services/common.service'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { QuoteCartService } from '../../../../quote/quote-services/quote-cart.service'
import { Observable, of } from 'rxjs'
import { AuthService, User } from '@spartacus/core'
import { switchMap } from 'rxjs/operators'
import { Router, NavigationEnd } from '@angular/router'
import { ActiveCartFacade } from '@spartacus/cart/base/root'

import {
  Ecommerce,
  EcommerceItem,
  GTMDataLayer,
  GTMCartType
} from '../../../../../shared/models/googleTagManager.model';
import {
  ItemListTypeEnum,
  GtmEvents,
  StoreTypeEnum,
} from '../../../../../shared/enums/gtm.enum';
import { GoogleTagManagerService } from '../../../../../shared/services/gtm.service';

@Component({
  standalone: false,
  selector: 'vs-mini-cart-details',
  templateUrl: './mini-cart-details.component.html',
  styleUrls: ['./mini-cart-details.component.scss'],
})
export class MiniCartDetailsComponent implements OnInit {
  public ProductDetails
  @Output() closeMiniCartDetails = new EventEmitter<boolean>()
  public cartId
  public cartStatus
  cartLoaded = false
  cart: any
  mySubscription: any
  user$: Observable<User>
  cartData$: Observable<User>
  cartData: any
  userType: string
  activeCart: any
  prodname: any
  prodobj: any
  prodprice: any
  prodcategory: any
  prodcode: any
  prodcodeobj: any
  prodobjimg: any
  constructor(
    private router: Router,
    private commonService: CommonService,
    protected cartService: ActiveCartFacade,
    private globalMessageService: GlobalMessageService,
    private gtmService: GoogleTagManagerService
  ) {
    this.cartService.getActiveCartId().subscribe(
      (data) => {
        this.cartId = data
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  ngOnInit(): void {
    this.getMiniCArtDetails()
  }
  getMiniCArtDetails() {
    this.cartService.getActive().subscribe(
      (success) => {
        this.cart = success

        if (this.cart.entries) {
          this.prodname = this.cart.entries
        }
        //this.cartdetail = true;
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  closeMiniCart(event) {
    this.closeMiniCartDetails.emit(false)

    const viewcartItemsData: any[] = [];
    let totalValue = 0;
    this.prodname.forEach((itemEl, index) => {
      viewcartItemsData.push({
        item_id: itemEl?.product?.code,
        item_name: itemEl?.product?.name,
        index: index,
        item_list_id: ItemListTypeEnum.Cart,
        item_list_name: ItemListTypeEnum.Cart,
        price: itemEl?.totalPrice?.value,
        quantity: itemEl?.quantity,
      });
      totalValue += itemEl?.totalPrice?.value * itemEl?.quantity;
    });
    const viewCartDataLayer: GTMDataLayer = {
      event: GtmEvents.ViewCart,
      ecommerce: {
        currency: this.prodname[0]?.netPrice.currencyIso,
        value: totalValue,
        items: viewcartItemsData,
      },
      commerceType: GTMCartType.BUY_CART,
      cart_id: this.cartId
    };
    this.gtmService.sendEvent(viewCartDataLayer);
  }

  setProductDetailsGTM(product){
    if (product !== null && product !== undefined) {
      const viewItemDataLayer: GTMDataLayer = {
        event: GtmEvents.ViewItem,
        ecommerce: {
        currency: product?.netPrice?.currencyIso || '',
        value: product?.netPrice?.value || '',
        items: [
          {
            item_id: product?.code,
            item_name: product?.name,
            index: 0,
            item_category: product?.categories[0]?.name || '',
            item_category2: product?.categories[1]?.name || '',
            item_category3: product?.categories[2]?.name || '',
            item_category4: product?.categories[3]?.name || '',
            item_category5: product?.categories[4]?.name || '',
            item_list_id: ItemListTypeEnum.ProductDetail,
            item_list_name: ItemListTypeEnum.ProductDetail,
            price: product?.netPrice?.value
          },
        ],
        },
      };
      
      if (
        product &&
        product?.estShipData &&
        product?.estShipData[0]?.stockQty
      ) {
        viewItemDataLayer.ecommerce.items[0].quantity = Number(
        product?.estShipData[0]?.stockQty
        );
      }

      this.gtmService.sendEvent(viewItemDataLayer);
    }
  }
}
